import '../../stylesheets/dashboards/dashboards.css'
import '../../stylesheets/dashboards/leaderboard.css'
import '../../stylesheets/skeletons/gridSkeletons.css'

const GridSkeleton = () => {
    // one summary cell per index the summary stats section renders (S&P 500 + Nasdaq)
    const summaryCells      = Array.from({ length: 2 })
    // mirrors the first 8 companies Main seeds selectedCompanyIds with
    const selectedCells     = Array.from({ length: 8 })
    // sector sizes vary, so just enough cells to read as a full sector grid at every viewport width
    const sectorCells       = Array.from({ length: 24 })

    return (
        <div className="page-wrapper">
            <div className="dashboard">

                {/* 1. Left Panel */}
                <div className="left-panel">

                    {/* Left Section 1: Header Section */}
                    <div className="left-panel-header-container">
                        <h2 className="panel-title">Selected Companies</h2>
                    </div>

                    {/* Left Section 2: Body Section */}
                    <div className="left-panel-body-container">
                        <div className="summary-stats-container">
                            {summaryCells.map((_, i) => (
                                <div className="grid-skeleton-summary-cell" key={i}></div>
                            ))}
                        </div>
                        <div className="leaderboard-grid-container">
                            {selectedCells.map((_, i) => (
                                <div className="grid-skeleton-cell" key={i}></div>
                            ))}
                        </div>
                    </div>

                </div>

                {/* 2. Right Panel */}
                <div className="right-panel">

                    {/* Right Section 1: Header Section */}
                    <div className="right-panel-header-container">
                        <h2 className="panel-title">Movement</h2>
                        <div className="right-panel-leaderboard-controls-container">
                            <div className="grid-skeleton-toggle period"></div>
                            <div className="grid-skeleton-toggle type"></div>
                        </div>
                    </div>

                    {/* Right Section 2: Body Section */}
                    <div className="charts-container">
                        <div className="chart-section">
                            <div className="grid-skeleton-chart-title"></div>
                            <div className="leaderboard-grid-container">
                                {sectorCells.map((_, i) => (
                                    <div className="grid-skeleton-cell" key={i}></div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default GridSkeleton;
